import {Module, Mutation, VuexModule} from 'vuex-module-decorators';
import Store from './index';
import {Strophe} from "@/xmpp/Strophe";

@Module({
    store: Store,
    name: 'XMPPStore',
    dynamic: true,
})
export class XMPPStore extends VuexModule {
    public connection = new Strophe.Connection("/http-bind/", {sync: true});

    @Mutation
    public setCurrentConnection(c: Strophe.Connection) {
        this.connection = c;

    }

}
